/* eslint-disable @typescript-eslint/no-explicit-any */
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { AUTH_LOGOUT } from '@portal/actions/actionTypes';
import '@portal/i18n/config';

import accountReducer from './account';
import authReducer from './auth';
import bankReducer from './bank';
import cardsReducer from './cards';
import cashbackReducer from './cashback';
import detailsReducer from './details';
import deviceReducer from './device';
import faqReducer from './faq';
import favoredContactReducer from './favoredContact';
import homeReducer from './home';
import limitReducer from './limits';
import loadingReducer from './loading';
import loanReducer from './loan';
import notificationReducer from './notification';
import onboardingReducer from './onboarding';
import payableReducer from './payable';
import payStubReducer from './payStub';
import pixReducer from './pix';
import salaryPortabilityReducer from './salaryPortability';
import settingsReducer from './settings';
import transactionReducer from './transaction';
import userReducer from './user';
import receivableReducer from './receivable';
import investmentsReducer from './investments';
import groupReducer from './group';
import remitReducer from './remit';
import employeesReducer from './employees';
import paymentAccountReducer from './paymentAccount';
import condominiumsReducer from './condominiums';
import payslipReducer from './payslip';
import occupationsReducer from './occupations';
import approvedReducer from './approveTransaction';
import userImpersonationReducer from './userImpersonation';
import productsReducer from './products';
import themeReducer from './theme';

const appReducer = combineReducers({
  account: accountReducer,
  auth: authReducer,
  bank: bankReducer,
  cards: cardsReducer,
  cashback: cashbackReducer,
  details: detailsReducer,
  device: deviceReducer,
  faq: faqReducer,
  group: groupReducer,
  favoredContacts: favoredContactReducer,
  home: homeReducer,
  investments: investmentsReducer,
  limit: limitReducer,
  loading: loadingReducer,
  loan: loanReducer,
  notification: notificationReducer,
  onboarding: onboardingReducer,
  payable: payableReducer,
  paymentAccount: paymentAccountReducer,
  payStub: payStubReducer,
  pix: pixReducer,
  receivable: receivableReducer,
  salaryPortability: salaryPortabilityReducer,
  settings: settingsReducer,
  transactions: transactionReducer,
  user: userReducer,
  remit: remitReducer,
  employees: employeesReducer,
  condominiums: condominiumsReducer,
  payslip: payslipReducer,
  occupationCbo: occupationsReducer,
  userImpersonation: userImpersonationReducer,
  approved: approvedReducer,
  products: productsReducer,
  theme: themeReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === AUTH_LOGOUT) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

const windowObj: any = window;
const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk),
    windowObj.__REDUX_DEVTOOLS_EXTENSION__
      ? windowObj.__REDUX_DEVTOOLS_EXTENSION__()
      : (f: any) => f
  )
);

export default store;
